// @flow

import React from 'react';
import classNames from 'classnames';

import type {Node, StatelessFunctionalComponent} from 'react';

export type Props = {|
    children: () => Node,
    empty: boolean,
|};

export const Navigation: StatelessFunctionalComponent<Props> = ({empty, children}) => {
    const className = classNames('data-table__nav', {
        'data-table__nav_empty': empty
    });

    return (
        <div className="data-table__navigation-container">
            <div className={className}>
                {children()}
            </div>
        </div>
    );
};
